import { throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { EnvironmentsService } from './core/services/environments.service'
import { EnvironmentsConfigsInterface } from './core/interfaces/environments-configs.interface'

export function InitEnviroments(environmentsService: EnvironmentsService): () => Promise<EnvironmentsConfigsInterface> {
	return (): Promise<EnvironmentsConfigsInterface> => {
		return environmentsService
			.getEnvironmentsConfigs()
			.pipe(
				catchError((error) => {
					console.error('Не удалось загрузить конфиг окружения', error)
					return throwError(error)
				}),
			)
			.toPromise()
	}
}
